import React from "react";
import Image from "next/image";
import { m } from "framer-motion";
export default function Banner({ image, heading }) {
  return (
    <div className="w-full md:h-[450px] h-[400px] relative">
      <Image
        src={"/images/Orange & Purple Geometric Tehnology Linkdln Banner.webp"}
        alt={heading}
        fill
        className="object-cover object-center"
        sizes="(max-width: 479px) 700px,(max-width: 768px) 700px, (max-width: 1200px) 700px,(max-width: 1920px) 700px, 500px"
      />
      <div
        className="absolute md:pt-0 pt-8 top-0 left-0 w-full h-full flex flex-col gap-2 justify-center px-[5vw]"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgb(45, 39, 106) 20%, rgba(45, 39, 106, 0.8) 40%, rgba(45, 39, 106, 0.4) 60%, rgba(0, 0, 0, 0) 80%)",
        }}
      >
        <m.h1
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 100 }}
          transition={{ duration: 0.75, delay: 0.2 }}
          className="md:text-5xl text-4xl font-semibold text-white w-fit"
        >
          {heading}
        </m.h1>
      </div>
    </div>
  );
}
